export default class ChannelDomain {
  id: string;

  channelName: string;

  identifier: string;

  countryCode?: string;

  displayName?: string | null;

  getDisplayChannelName(): string {
    switch (this.channelName) {
      case "sms":
        return "SMS";
      case "whatsapp":
        return "WhatsApp";
      case "instagram":
        return "Instagram";
      case "facebook":
        return "Facebook";
      case "email":
        return "Email";
      default:
        return "";
    }
  }

  static getChannelName(channelName: string): string {
    switch (channelName) {
      case "sms":
        return "SMS";
      case "whatsapp":
        return "WhatsApp";
      case "instagram":
        return "Instagram";
      case "facebook":
        return "Facebook";
      case "email":
        return "Email";
      default:
        return "";
    }
  }

  constructor(
    id: string,
    channelName: string,
    identifier: string,
    countryCode?: string,
    displayName?: string | null
  ) {
    this.id = id;
    this.channelName = channelName;
    this.identifier = identifier;
    this.countryCode = countryCode;
    this.displayName = displayName;
  }
}
